import { Bus, Sparkles } from 'lucide-react'

import { cn } from '../cn'
import { badgeVariants } from './badge'
import { ordoLightBadgeClassName } from './tag-chip'

/** Named service, distinct from dietary claims. Shared by authoring and ordering. */
export function MenuServiceBadge({ kind, label }: { kind: 'holiday' | 'field-trip'; label: string }) {
  const Icon = kind === 'holiday' ? Sparkles : Bus
  return (
    <span
      className={cn(
        badgeVariants({
          variant: 'secondary',
          className: 'max-w-full gap-1 whitespace-normal text-left text-[10px] font-semibold uppercase tracking-wide',
        }),
        ordoLightBadgeClassName(kind === 'holiday' ? 'violet' : 'teal'),
      )}>
      <Icon className="size-3 shrink-0" aria-hidden="true" />
      {label}
    </span>
  )
}
